import React, { useEffect, useState } from 'react'
import { logo, profile } from '../../assets/imgs';

const Topbar = () => {

    const [saideBarShow, setSaidBarShow] = useState(true);
    const [name, setName] = useState();

    useEffect(() => {
        let userName = JSON.parse(localStorage.getItem("loggedUser"))
        setName(userName?.username);
    }, [])

    const toggle_nav = () => {
        setSaidBarShow(!saideBarShow);
    };
    return (
        <div className='d-flex ac-jb topbar'>
            <div className='d-flex ac-jc'>
                <div className=" pointer"  >
                    <img src={logo} className="nav-logo" alt="" />
                </div>
            </div>
            <div className='d-flex ac-jc'>
                {/* <img src={profile} className="profile-img" alt="" /> */}
                <p className="f4 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mb-0 ps-2 py-3 sec">
                    Welcome {name}
                </p>
            </div>
        </div>
    )
}

export default Topbar